import { useModals } from '@customerio/pluma-components/react';
import { isEmptyString } from '@/utils/string';
import { FeatureFeedbackModal } from './components/feature-feedback-modal';
import { GeneralFeedbackModal } from './components/general-feedback-modal';
import type { FeedbackFormValues, ShowFeedbackModalOptions } from './types';

export function useCustomerFeedback() {
  const modals = useModals();

  const showFeedbackModal = async (options: ShowFeedbackModalOptions = {}) => {
    const { feature, initialFeedback, onSubmit, onCancel } = options;

    if (!isEmptyString(feature)) {
      const modalId = modals.open(FeatureFeedbackModal, { feature, initialFeedback });
      const result = await modals.waitForClose(modalId);

      if (result.reason === 'confirm' && result.data != null) {
        onSubmit?.(result.data as FeedbackFormValues);
      } else if (result.reason === 'close') {
        onCancel?.();
      }
    } else {
      const modalId = modals.open(GeneralFeedbackModal, { initialFeedback });
      const result = await modals.waitForClose(modalId);

      if (result.reason === 'confirm' && result.data != null) {
        onSubmit?.(result.data as FeedbackFormValues);
      } else if (result.reason === 'close') {
        onCancel?.();
      }
    }
  };

  return showFeedbackModal;
}
